<template>
  <transition name="fade">
    <div v-if="loading" class="loader-overlay">
      <div class="loader-wrapper">
        <span class="loader-letter">Y</span>
        <span class="loader-letter">u</span>
        <span class="loader-letter">k</span>
        <span class="loader-letter">l</span>
        <span class="loader-letter">a</span>
        <span class="loader-letter">n</span>
        <span class="loader-letter">m</span>
        <span class="loader-letter">o</span>
        <span class="loader-letter">q</span>
        <span class="loader-letter">d</span>
        <span class="loader-letter">a</span>
        <div class="loader"></div>
      </div>
    </div>
  </transition>
</template>


<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
  name: 'TextLoader',
  setup() {
    const store = useStore()
    const loading = computed(() => store.getters.isLoading)
    return { loading }
  }
}
</script>

<style scoped>
.fade-enter-active {
  animation: fadeIn 0.1s ease-in;
}
.fade-leave-active {
  animation: fadeOut 0.5s ease-out; /* Sekinroq yo‘qolish uchun 1.2s */
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.6); /* Orqa fonni qorong‘iroq qilish */
  z-index: 10000; /* Yuqori z-index */
}

.loader-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 180px;
  height: 180px;
  font-family: "Inter", sans-serif;
  font-size: 1.2em;
  font-weight: 300;
  color: white;
  border-radius: 50%;
  background-color: transparent;
  user-select: none;
  box-shadow: 0 0 20px rgba(255, 255, 255, 0.3); /* Loader atrofida yorqin soya */
}

.loader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 50%;
  background-color: transparent;
  animation: loader-rotate 2s linear infinite;
  z-index: 0;
}

@keyframes loader-rotate {
  0% {
    transform: rotate(90deg);
    box-shadow:
      0 10px 20px 0 #fff inset,
      0 20px 30px 0 #ad5fff inset,
      0 60px 60px 0 #471eec inset;
  }
  50% {
    transform: rotate(270deg);
    box-shadow:
      0 10px 20px 0 #fff inset,
      0 20px 10px 0 #d60a47 inset,
      0 40px 60px 0 #311e80 inset;
  }
  100% {
    transform: rotate(450deg);
    box-shadow:
      0 10px 20px 0 #fff inset,
      0 20px 30px 0 #ad5fff inset,
      0 60px 60px 0 #471eec inset;
  }
}

.loader-letter {
  display: inline-block;
  opacity: 0.4;
  transform: translateY(0);
  animation: loader-letter-anim 2s infinite;
  z-index: 1;
  border-radius: 50ch;
  border: none;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.8); /* Harflarga yorqinlik qo‘shish */
}

.loader-letter:nth-child(1) { animation-delay: 0s; }
.loader-letter:nth-child(2) { animation-delay: 0.1s; }
.loader-letter:nth-child(3) { animation-delay: 0.2s; }
.loader-letter:nth-child(4) { animation-delay: 0.3s; }
.loader-letter:nth-child(5) { animation-delay: 0.4s; }
.loader-letter:nth-child(6) { animation-delay: 0.5s; }
.loader-letter:nth-child(7) { animation-delay: 0.6s; }
.loader-letter:nth-child(8) { animation-delay: 0.7s; }
.loader-letter:nth-child(9) { animation-delay: 0.8s; }
.loader-letter:nth-child(10) { animation-delay: 0.9s; }
.loader-letter:nth-child(11) { animation-delay: 1s; }

@keyframes loader-letter-anim {
  0%, 100% {
    opacity: 0.4;
    transform: translateY(0);
  }
  20% {
    opacity: 1;
    transform: scale(1.15);
  }
  40% {
    opacity: 0.7;
    transform: translateY(0);
  }
}
</style>